import React, { FC } from "react";

import "../styles.scss";
import "../scripts";

import {
  primaryBlock,
  PrimaryBlockConfig,
  getDefaultProps,
  KameleonElement,
  SecondaryBlockSize,
  TertiaryBlockSize,
  BlockTheme,
  renderSecondaryBlock,
  BlockType,
} from "@kameleon-core/lib";
import { Box } from "theme-ui";

import {
  backgroundColorModeMapper,
  Variants,
} from "@kameleon-util/global-theme";
import { webflowHOC } from "@kameleon-common/webflow-js";
import blockinfo from "./blockinfo.json";
import defaults from "./defaults.json";
import { ContentType, layoutOptions } from "./types/prop-types";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import getEvents from "./js/webflow";

/** Content Primary */
const blockConfig: PrimaryBlockConfig = {
  secondaryBlockSize: SecondaryBlockSize.ExtraSmall,
  tertiaryBlockSize: TertiaryBlockSize.None,
  blockType: BlockType.Primary,
  blockTheme: BlockTheme.dark,
};

const ContentComponent: FC<ContentType> = ({
  items,
  SecondaryBlock,
  tagline,
  header,
  layoutProps,
}: ContentType) => {
  const headerAlignmentIsLeft = layoutProps.headerAlignment === "left";
  const headerPlacementIsLeft = layoutProps.headerPlacement === "left";
  return (
    <Box className="primary-content-two-col-timeline-v1 section_layout121">
      <Box className="padding-global">
        <Box className="container-large padding-section-large layout121_component">
          <Box
            sx={{
              order: headerPlacementIsLeft ? -1 : 1,
              textAlign: headerAlignmentIsLeft ? "left" : "center",
            }}
            className="layout121_content-left"
          >
            {tagline && (
              <Box className="margin-bottom margin-xsmall">
                <Variants.TagLine>{tagline}</Variants.TagLine>
              </Box>
            )}
            <Variants.Heading>{header}</Variants.Heading>
            {renderSecondaryBlock(SecondaryBlock)}
          </Box>
          <Box className="layout121_content-right">
            <Box
              data-w-id="1acb1df5-4f62-72c8-ccf1-49c8e1a23efa"
              className="layout121_timeline-wrapper"
            >
              <Variants.TimelineProgress className="layout121_progress-bar-wrapper">
                <Variants.TimelineIndicator className="layout121_progress-bar" />
              </Variants.TimelineProgress>
              {items.map((item, i) => (
                <Box
                  key={i}
                  data-w-id="1acb1df5-4f62-72c8-ccf1-49c8e1a23efd"
                  className="layout121_timeline-step"
                >
                  <Box className="layout121_timeline-left">
                    <Box
                      sx={{
                        backgroundColor: backgroundColorModeMapper(
                          layoutProps.backgroundColor
                        ).color,
                      }}
                      className="layout121_timeline-icon-wrapper"
                    >
                      <Variants.IconSmall
                        icon={item.icon}
                        className="icon-1x1-medium"
                      />
                    </Box>
                  </Box>
                  <Box className="layout121_timeline-right">
                    <Box className="layout121_text-wrapper">
                      <Box className="margin-bottom margin-xsmall">
                        <Variants.Heading as="h3" variant="h6">
                          {item.title}
                        </Variants.Heading>
                      </Box>
                      <Variants.ParagraphDefault>
                        {item.description}
                      </Variants.ParagraphDefault>
                    </Box>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

const ComponentWithWebflow = webflowHOC(ContentComponent, [
  {
    module: "ix2",
    getEvents: (pageId: any): any => getEvents(pageId),
  },
]);

export const Content = primaryBlock<ContentType>(
  blockConfig,
  ComponentWithWebflow
);
Content.defaultProps = getDefaultProps<ContentType>(defaults);

export const Element: KameleonElement = {
  component: Content,
  blockInfo: blockinfo,
  defaultProps: {
    layoutProps: defaults.layoutProps,
    contentProps: defaults.contentProps,
  },
  layoutOptions,
};
